import axios, { AxiosRequestConfig } from "axios";
import { getData, removeData } from "../helper/arrayFormatter";

// Request interceptor to add Authorization token
const addAuthorizationToken = (config: any) => {
	const userData = getData("user");

	if (userData) {
		try {
			const parsedUser = JSON.parse(userData);
			if (parsedUser.token) {
				// Attach the token to the request headers
				config.headers = {
					...config.headers,
					Authorization: `Bearer ${parsedUser.token}`,
				};
			}
		} catch (error) {
			console.error("Error parsing user data:", error);
		}
	}

	return config;
};

// Response interceptor to handle token expiration or invalid token
const handleAuthorizationError = (error: any) => {
	if (error.response?.status === 401 || error.response?.data?.message === "Invalid token") {
		removeData("user");
		removeData("token");
		window.location.reload();
	}
	return Promise.reject(error);
};

// Custom axios instance with interceptors
const api = axios.create();

api.interceptors.request.use(addAuthorizationToken, (error) => Promise.reject(error));

api.interceptors.response.use(
	(response) => response,
	handleAuthorizationError
);

// Custom axios methods
export const axiosPost = (url: string, payload: object, config: AxiosRequestConfig = {}) => {
	return api.post(url, payload, config);
};

export const axiosGet = (url: string, config: AxiosRequestConfig = {}) => {
	return api.get(url, config);
};

export const axiosPut = (url: string, body: object, config: AxiosRequestConfig = {}) => {
	return api.put(url, body, config);
};

export const axiosDelete = (url: string, body: object, config: AxiosRequestConfig = {}) => {
	return api.delete(url, { data: body, ...config });
};
